import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_MEMBERSHIP_STRIPE_PAYMENT_ELEMENTS_TRANSLATIONS = defineFcm(
	'revenue_membership_stripe_payment_elements_translations',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				// Manual translation overrides keyed by string id (e.g. `your_details`). A plain FC (no
				// experiment) so it can be added to incrementally and cleaned up quickly once the real
				// translations land.
				strings: {
					type: 'record',
					optional: true,
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Join Page',
		description:
			'Manual translation overrides for the Stripe Payment Elements layout on the Membership Join Page (e.g. the "Your details" section)',
		template: {
			enabled: false,
			strings: {},
		},
	});
